import {match} from 'ts-pattern';

import {
  AddressResponseBodyV2,
  BusinessInfoDataResponseBody,
  CustomerResponseBodyV2,
  LegalForm,
  PersonResponseBodyV2,
} from '@dms/api/customer';
import {LegalFormEnum} from '@dms/teas';

type BillingSource = {
  legalForm: LegalForm;
  businessInfoData: BusinessInfoDataResponseBody | null;
  address: AddressResponseBodyV2 | null;
  person: PersonResponseBodyV2 | null;
};

export const getBillingSource = (customer: CustomerResponseBodyV2) =>
  match<CustomerResponseBodyV2, BillingSource>(customer)
    .with({selfEmployed: true}, (selfEmployed) => ({
      legalForm: LegalFormEnum.SELF_EMPLOYED,
      businessInfoData: selfEmployed.selfEmployedBusinessInfoData,
      address: selfEmployed.selfEmployedBusinessAddress,
      person: null,
    }))
    .with({discriminator: 'BUSINESS'}, (business) => ({
      legalForm: LegalFormEnum.LEGAL_ENTITY,
      businessInfoData: business.businessInfo?.businessInfo ?? null,
      address: business.businessInfo?.address ?? null,
      person: null,
    }))
    .otherwise((person) => ({
      legalForm: LegalFormEnum.NATURAL_PERSON,
      businessInfoData: null,
      address: person.foundingPerson?.permanentAddress ?? null,
      person: person.foundingPerson,
    }));
